import { CheckCircle2, Quote } from "lucide-react";
import { VISION, MISSION, CORE_VALUES, HOSPITAL } from "../lib/hospitalData";

export default function About() {
  return (
    <main data-testid="page-about">
      {/* Page Hero */}
      <section className="bg-brand-cream relative overflow-hidden">
        <div className="absolute inset-0 grain opacity-40" />
        <div className="container-x py-14 md:py-28 relative">
          <div className="text-xs tracking-[0.25em] uppercase text-brand-crimson font-semibold reveal">About Us</div>
          <h1 className="font-display text-[34px] sm:text-5xl lg:text-6xl font-bold text-brand-navy-deep mt-4 max-w-4xl leading-[1.05] reveal reveal-1">
            A new chapter in cardiac care for <span className="italic text-brand-crimson">Godhra & Panchmahal.</span>
          </h1>
          <p className="mt-5 md:mt-6 text-base md:text-lg text-slate-700 max-w-3xl leading-relaxed reveal reveal-2">
            {HOSPITAL.name} is a newly established 75-bed multi-specialty hospital, founded with a single purpose — to bring world-class cardiac and super-specialty healthcare within reach of every family in the region.
          </p>
        </div>
      </section>

      {/* Vision */}
      <section className="py-16 md:py-24" data-testid="about-vision">
        <div className="container-x grid lg:grid-cols-12 gap-8 lg:gap-10">
          <div className="lg:col-span-4">
            <div className="text-xs tracking-[0.25em] uppercase text-brand-crimson font-semibold">Our Vision</div>
            <h2 className="font-display text-[30px] sm:text-4xl md:text-5xl font-bold text-brand-navy-deep mt-3 leading-tight">A center of excellence for the community.</h2>
          </div>
          <div className="lg:col-span-8 relative">
            <Quote className="w-10 h-10 md:w-12 md:h-12 text-brand-crimson/15 absolute -top-3 md:-top-4 -left-1 md:-left-2" />
            <p className="text-base md:text-lg text-slate-700 leading-relaxed pl-4 border-l-2 border-brand-crimson">
              {VISION}
            </p>
          </div>
        </div>
      </section>

      {/* Mission */}
      <section className="py-16 md:py-24 bg-brand-navy-deep text-white relative overflow-hidden" data-testid="about-mission">
        <div className="absolute inset-0 grain opacity-30" />
        <div className="container-x relative">
          <div className="max-w-2xl">
            <div className="text-xs tracking-[0.25em] uppercase text-brand-crimson font-semibold">Our Mission</div>
            <h2 className="font-display text-[30px] sm:text-4xl md:text-5xl font-bold mt-3 leading-tight">Five commitments that guide us every day.</h2>
          </div>
          <div className="mt-10 md:mt-14 grid md:grid-cols-2 gap-4 md:gap-5">
            {MISSION.map((m, i) => (
              <div key={i} className={`bg-white/5 border border-white/10 rounded-2xl p-5 md:p-7 hover:bg-white/10 transition-colors reveal reveal-${(i%5)+1}`}>
                <div className="flex items-start gap-4">
                  <div className="w-9 h-9 rounded-full bg-brand-crimson flex items-center justify-center text-white font-display font-bold shrink-0">{i+1}</div>
                  <p className="text-white/85 leading-relaxed">{m}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Core Values */}
      <section className="py-16 md:py-24" data-testid="about-values">
        <div className="container-x">
          <div className="max-w-2xl mx-auto text-center">
            <div className="text-xs tracking-[0.25em] uppercase text-brand-crimson font-semibold">Core Values</div>
            <h2 className="font-display text-[30px] sm:text-4xl md:text-5xl font-bold text-brand-navy-deep mt-3 leading-tight">The principles behind every heartbeat we care for.</h2>
          </div>
          <div className="mt-10 md:mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {CORE_VALUES.map((v, i) => (
              <div key={v.title} className={`card-lift bg-white border border-border rounded-2xl p-7 reveal reveal-${(i%5)+1}`}>
                <CheckCircle2 className="w-7 h-7 text-brand-crimson" />
                <h3 className="font-display text-xl text-brand-navy-deep mt-4">{v.title}</h3>
                <p className="text-sm text-slate-600 mt-2 leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
